// @ts-nocheck


import React, { Component } from 'react';
import { navigate } from '../../../lib/routerAdapter';

import { Tabs, TabItem } from '../../../components/ui';

import { vehicleTariffEnum } from '../../../lib/enum';





const COMMON_ROUTE = 'vehicle-tariff';

export default class HeaderTabs extends Component {
  render() {
    return (
      <Tabs defaultTab={this.props.selectedTab}>
        <TabItem
          tabKey={vehicleTariffEnum.byBrand}
          label="По марке модели"
          onClick={() =>
          navigate(`/admin/${COMMON_ROUTE}/${vehicleTariffEnum.byBrand}`)
          } />

        <TabItem
          tabKey={vehicleTariffEnum.byType}
          label="По типу ТС"
          onClick={() =>
          navigate(`/admin/${COMMON_ROUTE}/${vehicleTariffEnum.byType}`)
          } />

      </Tabs>);

  }
}
